var _path, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrosoft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1794.1 1782.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1380.2 451.5v-40c0-108.6-51.7-210.6-139.2-274.9 44.5 59 68.5 130.9 68.4 204.8v110.1h-71V341.4C1238.5 152.9 1085.6 0 897.1 0S555.6 152.9 555.6 341.4v110.1H0v1200.7c0 71.8 58.2 130.1 130.1 130.1h1534c71.8 0 130.1-58.2 130.1-130.1V451.5h-414zM626.4 341.4c-.1-149.4 121-270.6 270.5-270.6h.2c148.1 3.2 267.4 122.5 270.7 270.7v110.1H768.1v-40c-.1-149.4 121-270.6 270.5-270.7h.2c12.5 0 24.9.9 37.2 2.8-33.9-15.6-70.7-23.7-108-23.8-87.5-.1-169.7 42.3-220.4 113.6-32.9 53.6-50.3 115.2-50.2 178v40h-71V341.4z",
    fill: "#e8e8e8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 520.9,
    y: 740.5,
    width: 347.2,
    height: 347.3,
    fill: "#f25022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 926,
    y: 740.5,
    width: 347.2,
    height: 347.3,
    fill: "#7fba00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 520.9,
    y: 1145.6,
    width: 347.2,
    height: 347.2,
    fill: "#00a4ef"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 926,
    y: 1145.6,
    width: 347.2,
    height: 347.2,
    fill: "#ffb900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.9c1361d6c476a9023222b7c2e555b20c.svg";
export { ForwardRef as ReactComponent };